export class CommonCsvContentBuilder {

    sanitizeText(text: string): string {
        if (!text) {
            return '';
        }
        text = this.removeSeparators(text);
        text = this.removeHtmlTags(text);
        return this.removeBreakLines(text);
    }

    removeHtmlTags(text: string): string {
        if (!text) {
            return text;
        }
        return text.replace(/<\/?[^>]+(>|$)/g, '');
    }

    removeBreakLines(text: string): string {
        if (!text) {
            return text;
        }
        return text.replace(/[\r\n]/g, '');
    }

    removeSeparators(text: string): string {
        if (!text) {
            return text;
        }
        return text.replace(';', '');
    }

}
